import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseApiService } from 'src/app/shared/services/base-api.service';

@Injectable({
  providedIn: 'root'
})
export class MenuDataService {

  private baseUrl: string = `${environment.appConfig.gatewayServiceBaseUrl}/api/portal/PortalAuthentication`;

  constructor(private baseApi: BaseApiService<any>) { }

  getUserMenu(): Observable<any> {
     const token = localStorage.getItem('authToken'); 
  return this.baseApi.Get(`${this.baseUrl}/user-pages`);
  }
}
